import { json, type LinksFunction } from '@remix-run/node';
import { getFlowDatumData } from '~/data/awards2024/config';
import stylesIndex from '~/styles/awards2024/rule.css';

export const links: LinksFunction = () => [
{
  rel: 'stylesheet',
  href: stylesIndex
}];


export async function loader() {
  return json({});
}


export default function Awards2024RulePage() {
  return <div className='page-rule'>
    <main className='rule-main'>
      <h3 className='rule-title'>RULES</h3>
      <section className='section section-01'>
        <span className='section-tit'>OVERVIEW</span>
        <div className='section-frame'>
          <p className='rule-text'>The GWB Game Awards is open to all indie game development teams worldwide - there is no restriction on the personal or corporate identity of the competitors. <em className='em'>Participation is 100% free and GWB will never ask for money in exchange for registration, a trophy or prize distribution.</em>
          </p>
        </div>
      </section>
      <section className='section section-02'>
        <span className='section-tit'>THE BASICS</span>
        <div className='section-frame'>
          <div className='rule-group'>
            <span className='rule-min-tit'>1. ELIGIBILITY</span>
            <p className='rule-text'>Entrants should not have been on sale prior to January 2024. Any game released after that point, or still in development at the time of awards entry, is eligible to take part. The awards includes both released and unreleased games.</p>
            <p className='rule-text'>Entries can include console games, VR, PC games, and mobile games (including H5).</p>
            <p className='rule-text'>To participate in the competition, participants or companies shall ensure that they have the right of use or copyright of the submitted projects and relevant authorization, and shall not involve the Organizing Committee in any copyright disputes or other intellectual property disputes.</p>
            <p className='rule-text'>For students participating in the University channel, only students in the final year of their studies are eligible.</p>
          </div>
          <div className='rule-group'>
            <span className='rule-min-tit'>2. GAME ACCESS</span>
            <p className='rule-text'>Participants agree that their projects will be submitted to the judging panel for review. In order to complete certain prize categories, this judging panel may include event partners.</p>
            <p className='rule-text'>For the materials provided by the entrant, the organizer has the right to use it for publicity (including social media content and offline activations), website display, etc. during and after the course of the event. Game builds will NOT be distributed by GWB for any purpose other than category judging by partners/judges.</p>
            <p className='rule-text'>In order to prevent delays at later judging stages, entrants will be required to submit access (e.g. a build link, keys etc.) for a minimum of 10 people. If considered for the finals and/or partner prizes,entrants may be asked to submit further keys.</p>
          </div>
          <div className='rule-group'>
            <span className='rule-min-tit'>3. DISQUALIFICATION CRITERIA</span>
            <p className='rule-text'>The organizer reserves the right to disqualify entries that are in clear violation of the competition rules, and reserves the right to refuse or withdraw event participation for any reason.</p>
            <p className='rule-text'>Games submitted after the submission period closes will be regarded as invalid.</p>
            <p className='rule-text'>Projects with incomplete materials (no pictures, no video, no introduction, no demo) or inconsistent contents will not be reviewed. For the purpose of evaluation, the game should be in a playable state so that it can be provided to the jury for review.</p>
            <p className='rule-text'>Projects need to be free of commercialization or have these features deactivated (e.g. in-app purchases, built-in advertising or other functions that can generate commercial benefits, including gambling and blockchain).</p>
          </div>
          <div className='rule-group'>
            <span className='rule-min-tit'>4. OTHER</span>
            <p className='rule-text'>Regarding prizes, relevant taxes may be deducted from cash prizes given for participation in GWB Awards activities.</p>
            <p className='rule-text'>All entrants in the GWB Game Awards are eligible for inclusion in offline and online promotional events. However, participation in the GWB is not a guarantee of inclusion in these events.</p>
          </div>
        </div>
      </section>
      <section className='section section-03'>
        <span className='section-tit'>JUDGING CRITERIA</span>
        <div className='section-frame'>
          <div className='rule-group'>
            <span className='rule-min-tit'>1. GENERAL</span>
            <p className='rule-text'>Unreleased games are expected to be at a 30% stage of completion or above. Demos and Early Access games are also permitted to take part. If you wish to update the build, please contact GWB staff and provide updated links/keys. Please note, it is not possible to repeat a stage of judging that has already been started or completed with a previous build.</p>
          </div>
          <div className='rule-group'>
            <span className='rule-min-tit'>2. CRITERIA</span>
            <p className='rule-text'>Internal judging will be scored according to a broad criteria which will include visuals, gameplay, music, theme etc. Extra consideration may be given to titles that show a high level of innovation, unique excecution and emotional, personal or cultural significance.</p>
            <div className='criteria'>
              <span className='criteria-tit'>
                JUDGING<br />
                CRITERIA<br />
                INCLUDES
              </span>
              <div className='criteria-list'>
                <span className='criteria-item'>Creativity</span>
                <span className='criteria-item'>Visuals</span>
                <span className='criteria-item'>Polish</span>
                <span className='criteria-item'>Audio</span>
              </div>
            </div>
            <p className='rule-text'>The final winners of the gold, silver and bronze awards will be decided by guest judges. In the event of a tie, scores from internal judging will be applied.</p>
            <p className='rule-text'>Partner Prizes will be decided by partners according to their own criteria.</p>
          </div>
          <div className='rule-group'>
            <span className='rule-min-tit'>3. TIMETABLE</span>
            <div className='flow'>
              {
              getFlowDatumData().data.map((item, i) =>
              <div className='flow__item' key={i}>
                    <span className='flow__name'>{item.name}</span>
                    <i className='flow__dot' />
                    <span className='flow__date'>{item.date}</span>
                  </div>
              )
              }
            </div>
          </div>
          <div className='rule-group'>
            <span className='rule-min-tit'>PLEASE NOTE:</span>
            <p className='rule-text'>There are several stages of judging that take place between July and September - if keys are given for a time-limited build and permissions are removed during this time, we cannot guarantee a title will be included in later stages of judging.<em className='em'>If you do need to revoke access to a build, please provide a new set of keys to the event organisers. </em>
            </p>
          </div>
        </div>
      </section>
      <section className='section section-04'>
        <span className='section-tit'>COPYRIGHT NOTICE</span>
        <div className='section-frame'>
          <p className='rule-text'>
            Awards participants maintain all intellectual property rights.
            Tencent GWB may use clips, videos and other media related to the entries for
            the production of publicity materials for events and related activities including,
            but not limited to, press releases, social media content, awards ceremonies,
            live events, online and offline activations, and game expos.
            <em className='em'>Tencent GWB will not distribute builds in any form without express permission for any purpose other than awards judging.</em>
          </p>
        </div>
      </section>
    </main>
  </div>;
};